(() => {
  window.swinger.eventHub.register('click', '.swinger-device-info > table + .swinger-button', (e) => {
    const elem = window.swinger.eventHub.getTarget(e);
    const wrapper = elem.closest('.swinger-device-info');
    const table = wrapper.querySelector('table');

    window.swinger.clipboard.copyRichText(table.outerHTML);
  });
})();
